<template>
  <div
    ref="optionRef"
    :class="{
      'bg-white hover:bg-blue-200': !disabled && !isSelected,
      'bg-gray-100': disabled,
      'cursor-pointer': !disabled,
      'cursor-not-allowed': disabled,
      'bg-blue-300 hover:bg-blue-300': isSelected,
    }"
    class="text-ellipsis overflow-hidden p-2"
    role="option"
    :aria-selected="isSelected"
    @click="selectMe"
    @mousedown="stopCloseTimer"
  >
    <slot>{{ label }}</slot>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, inject, onMounted, onBeforeUnmount, onUpdated, reactive } from 'vue';
import { PMSelectInjectionKey } from './SMSelect.types';

interface Props {
  value: string | number | boolean | undefined | null;
  disabled?: boolean;
  label?: string;
}

const props = defineProps<Props>();

const optionRef = ref<HTMLElement>();

const innerText = ref();

const label = computed(() => (props.label || (innerText.value as string)) ?? '');

const { addOption, selectOption, removeOption, selectedValue, stopCloseTimer } = inject(PMSelectInjectionKey)!;

const isSelected = computed(() => selectedValue.value === props.value);

const selectMe = () => {
  if (!props.disabled) {
    selectOption(props.value);
  }
};

onUpdated(() => {
  innerText.value = optionRef.value?.innerText;
});

onMounted(() => {
  innerText.value = optionRef.value?.innerText;
  addOption(
    props.value,
    reactive({
      ref: optionRef,
      selectMe,
      label: label!,
    })
  );
});

onBeforeUnmount(() => {
  removeOption(props.value);
});
</script>
